import elementBase from "../elementBase.js";

export default class DynamicTextInput extends elementBase {
    objectType = "DynamicTextInput";
    styleColor = '#553c9a'; // Violet foncé
    Background = '';
    Foreground = '';

    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }
    objectToClassValue(args = {}) {
        super.objectToClassValue(args);
        this.Background = args.background != null ? args.background : '#553c9a';
        this.Foreground = args.foreground != null ? args.foreground : '#553c9a';
    }
    static get Name() {
        return "Saisie de texte";
    }
    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            { name: "Background", type: "colorInput", dataType: "string" },
            { name: "Foreground", type: "colorInput", dataType: "string" },
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput")
        ];
    }
    getStyle(currentElementIndex = null) {
        let style = {
            ...super.getStyle(currentElementIndex),
            position: 'absolute',
        }
        return style;
    }
    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            background: this.hexColorValue(this.Background),
            foreground: this.hexColorValue(this.Foreground),
        };
    }
    toObject(minify = false) {
        let object = {
            ...super.toObject(minify),
            background: this.Background,
            foreground: this.Foreground,
        };
        return object;
    }
}
